import { render, staticRenderFns } from "./ModalRelacionar.vue?vue&type=template&id=2ff39c74"
import script from "./ModalRelacionar.vue?vue&type=script&lang=js"
export * from "./ModalRelacionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports